// This program has been developed by students from the bachelor Computer Science at
// Utrecht University within the Software Project course.
// © Copyright Utrecht University (Department of Information and Computing Sciences)

// internal imports
import generateBarSeries from '../data_interfaces/generateBarSeries'
import generateLineSeries from '../data_interfaces/generateLineSeries'
import generatePieSeries from '../data_interfaces/generatePieSeries'
import generateBoxplotSeries from '../data_interfaces/generateBoxplotSeries'
import generateHistogramSeries from '../data_interfaces/generateHistogramSeries'
import generateViolinSeries from '../data_interfaces/generateViolinSeries'

// Returns series data depending on the chart type,
// as each chart type expects data in a certain way.
// For example, a pie chart only expect one variable,
// whereas a bar chart expect two.
export default function generateSeries(settings) {
  switch (settings.chartType) {
    case 'bar':
      return generateBarSeries(settings)

    case 'line':
      return generateLineSeries(settings)

    case 'pie':
      return generatePieSeries(settings)

    case 'histogram':
      return generateHistogramSeries(settings)

    case 'boxplot':
      return generateBoxplotSeries(settings)

    case 'violin':
      return generateViolinSeries(settings)

    default:
      throw Error('visualization settings incorrect settings')
  }
}
